import { Controller } from "stimulus";
import * as Dynamsoft from "dynamsoft-barcode-reader-bundle";
export default class extends Controller {
  static targets = ["input"];

  static values = {
    env: String,
  };

  // Méthode appelée à la connexion du contrôleur
  async connect() {
    const object = this;

    //await barcodeCapture.setEnabled(true);
    $("#scanditModal").on("shown.bs.modal", async function (event) {
      object.enableScanner(event);
    });
    $("#scanditModal").on("hidden.bs.modal", async function (event) {
      object.disableScanner(event);
    });
  }
  async enableScanner(event) {
    try {
      // Charge les modules Dynamsoft
      await this.loadDynamsoftModules();
      // Initialise la licence Dynamsoft
      this.initLicense();
      // Charge le module principal (WASM)
      await this.loadCoreModule();
      // Configure la caméra et l'UI
      await this.setupCamera();
      // Configure le router pour la capture et le décodage
      await this.setupRouter();
      // Démarre la capture de codes-barres
      await this.startCapturing();
    } catch (error) {
      // Gère les erreurs d'initialisation
      this.handleError(error);
    }
  }

  // Charge dynamiquement les modules Dynamsoft nécessaires
  async loadDynamsoftModules() {
    // Stocke les modules dans l'instance
    this.CoreModule = Dynamsoft.CoreModule;
    this.LicenseManager = Dynamsoft.LicenseManager;
    this.CaptureVisionRouter = Dynamsoft.CaptureVisionRouter;
    this.CameraView = Dynamsoft.CameraView;
    this.CameraEnhancer = Dynamsoft.CameraEnhancer;
    this.MultiFrameResultCrossFilter = Dynamsoft.MultiFrameResultCrossFilter;
  }

  // Initialise la licence Dynamsoft
  initLicense() {
    this.LicenseManager.initLicense(
      this.envValue === "true"
        ? "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0NTM0MDQxLTEwNDk5OTA2OCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwNDUzNDA0MSIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NkbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJjaGVja0NvZGUiOjExNzkyNjI5MzJ9"
        : "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0NTM0MDQxLTEwNDk5OTA2OCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwNDUzNDA0MSIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NkbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJjaGVja0NvZGUiOjExNzkyNjI5MzJ9"
    );
  }

  // Charge le module principal Dynamsoft (WASM)
  async loadCoreModule() {
    this.CoreModule.engineResourcePaths.rootDirectory =
      "https://cdn.jsdelivr.net/npm/";
    await this.CoreModule.loadWasm();
  }

  // Configure la caméra et personnalise l'UI Dynamsoft
  async setupCamera() {
    // Crée les instances CameraView et CameraEnhancer
    this.cameraView = await this.CameraView.createInstance();
    this.cameraEnhancer = await this.CameraEnhancer.createInstance(
      this.cameraView
    );
    const dbrLayer = this.cameraView.getDrawingLayer(2);
    dbrLayer.setVisible(false);
    // Récupère le conteneur HTML pour l'affichage
    const container = document.getElementById("dynamsoft-barcode-picker");
    container.innerHTML = "";

    // Personnalisation de l'UI Dynamsoft via le shadow DOM
    const ui = await this.cameraView.getUIElement();
    this.setCustomVideoStyle(ui);
    // Ajoute l'UI personnalisée au conteneur
    container.append(ui);
    // Ouvre la caméra
    await this.cameraEnhancer.open();
  }

  // Personnalise le style de la vidéo
  setCustomVideoStyle(ui) {
    const shadowRoot = ui.shadowRoot;
    shadowRoot.querySelector("div").style.background = "transparent";
    shadowRoot.querySelector("dce-component div").style.borderRadius = "20px";

    // 1. Supprime les menus déroulants de sélection caméra/résolution
    shadowRoot.querySelector(".dce-sel-camera")?.remove();
    shadowRoot.querySelector(".dce-sel-resolution")?.remove();

    // 2. Supprime le logo "Powered by Dynamsoft"
    shadowRoot.querySelector(".dce-msg-poweredby")?.remove();

    // 3. Personnalise l'élément <video> pour l'affichage
    const video = shadowRoot.querySelector("video");
    if (video) {
      video.removeAttribute("style");
      video.style.aspectRatio = "1 / 1";
      video.style.objectFit = "cover";
      video.style.width = "100%";
      video.style.height = "100%";
      video.style.display = "block";
      video.style.margin = "auto";
      video.style.position = "relative";
      video.style.top = "unset";
      video.style.left = "unset";
      // Effet miroir (retournement horizontal)
      setTimeout(() => {
        video.style.transform = "scaleX(-1)";
      }, 100);
    }
  }

  // Configure le router Dynamsoft pour la capture et le décodage
  async setupRouter() {
    // Crée une instance du router
    this.cvRouter = await this.CaptureVisionRouter.createInstance();
    // Définit la caméra comme source d'entrée
    this.cvRouter.setInput(this.cameraEnhancer);

    // Ajoute un récepteur de résultats pour traiter les codes-barres décodés
    this.cvRouter.addResultReceiver({
      onDecodedBarcodesReceived: (result) => this.handleDecodedBarcodes(result),
    });

    // (Optionnel) Ajoute des filtres de résultats pour la vérification/dédoublonnage
    // const filter = new this.MultiFrameResultCrossFilter();
    // filter.enableResultCrossVerification("barcode", true);
    // filter.enableResultDeduplication("barcode", true);
    // await this.cvRouter.addResultFilter(filter);
  }

  // Démarre la capture de codes-barres
  async startCapturing() {
    // this.cameraView.setScanLaserVisible(true); // (optionnel) Affiche le laser de scan
    await this.cvRouter.startCapturing("ReadSingleBarcode");
  }

  // Traite les codes-barres décodés
  handleDecodedBarcodes(result) {
    if (!result.barcodeResultItems.length) return;
    // Arrête la capture après lecture
    this.cvRouter.stopCapturing();
    // Remplit l'input cible avec le texte du code-barres
    const input = document.querySelector("#product_ean");
    const value = result.barcodeResultItems[0].text;
    if (input && (input.value === null || input.value === "")) {
      input.value = value;
      $("#scanditModal").modal("hide");
      this.submitForm(input);
    }

    // Soumet le formulaire associé
    this.inputTarget.form.requestSubmit();
  }
  async submitForm(input) {
    this.disableVideoInstances();
    input.form.requestSubmit();
  }
  // Gère les erreurs d'initialisation ou d'exécution
  handleError(error) {
    console.error("[Dynamsoft] Échec de l'initialisation :", error);
    alert(error.message || error);
  }
  async disableScanner(event) {
    this.cvRouter?.dispose();
    this.cameraEnhancer?.dispose();
    this.cameraView?.dispose();
  }
  async disableVideoInstances() {
    this.cvRouter?.dispose();
    this.cameraEnhancer?.dispose();
    this.cameraView?.dispose();
  }
  // Nettoie les ressources à la déconnexion du contrôleur
  disconnect() {
    this.cvRouter?.dispose();
    this.cameraEnhancer?.dispose();
    this.cameraView?.dispose();
  }
}
